/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Privacy_Section_3_Item_Ai_DescInputs */

const en_privacy_section_3_item_ai_desc = /** @type {(inputs: Privacy_Section_3_Item_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`chatbot conversations are processed to provide helpful, context-aware responses about our services`)
};

const lv_privacy_section_3_item_ai_desc = /** @type {(inputs: Privacy_Section_3_Item_Ai_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`sarunas ar AI asistentu tiek apstrādātas, lai sniegtu noderīgas, kontekstam atbilstošas atbildes par mūsu pakalpojumiem`)
};

/**
* | output |
* | --- |
* | "chatbot conversations are processed to provide helpful, context-aware responses about our services" |
*
* @param {Privacy_Section_3_Item_Ai_DescInputs} inputs
* @param {{ locale?: "en" | "lv" }} options
* @returns {LocalizedString}
*/
export const privacy_section_3_item_ai_desc = /** @type {((inputs?: Privacy_Section_3_Item_Ai_DescInputs, options?: { locale?: "en" | "lv" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Privacy_Section_3_Item_Ai_DescInputs, { locale?: "en" | "lv" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "lv") return lv_privacy_section_3_item_ai_desc(inputs)
	return en_privacy_section_3_item_ai_desc(inputs)
});